
@if (header_info) {
  @for (el of header_info; track el) {
    <p class="d-inline-block mr-2r">
      {{el.caption}}: <b>{{el.count}}</b>
    </p>
  }
}

<div class="statistic-plagin__wrapper">
  <div class="material-datatable-wrapper">
    <app-datatable-headline
      [global_search_string]="global_search_string"
      [items_per_page_vars]="items_per_page_vars"
      (items_per_page_change)="itemPerPageChange($event)"
      (global_search_change)="onGlobalSearch($event)"
      [templateRight]="templateRight">
    </app-datatable-headline>
    <div class="table-responsive">
      <table class="table datatable" [ngClass]="cssClass">
        <thead app-data-table-head
          [sort]="sort"
          [columns]="columns"
          (sort_emmit)="onSortChange($event)">
        </thead>
        <tbody app-data-table-body
          (rowClick)="rowClick.emit($event)"
          [loading]="true"
          [columns]="columns">
        </tbody>
      </table>
    </div>
    <app-datatable-pagination
      [current_page]="current_page"
      (change_page)="changePage($event)">
    </app-datatable-pagination>
  </div>
</div>

<ng-template #subagent_id let-row="row">
  {{row['subagent_id']}}
</ng-template>

<ng-template #organisation_caption let-row="row">
  <a [routerLink]="['/entity/edit/', row['subagent_id']]">
    {{row['organisation_caption']}}
  </a>
</ng-template>

<ng-template #frame_is_active let-row="row">
  @switch (row['frame_is_active']) {
    @case (true) {
      Да
    }
    @case (false) {
      Нет
    }
  }
</ng-template>

<ng-template #frame_site let-row="row">
  @if (row['correct_url']) {
    <a href="{{row['correct_url']}}" target="_blank">{{row['correct_url']}}</a>
  }
  @if (!row['correct_url']) {
    {{row['frame_site']}}
  }
</ng-template>

<ng-template #cnt_complexes let-row="row">
  @switch (row['cnt_complexes']) {
    @case ('all') {
      Все
    }
    @default {
      {{row['cnt_complexes']}}
    }
  }
</ng-template>

<ng-template #frame_cnt_requests let-row="row">
  {{row['frame_cnt_requests']}}
</ng-template>

<ng-template #frame_cnt_appeals let-row="row">
  <a title="Просмотр" [routerLink]="['/statistic/plugin/', row.frame_www_uuid]">
    {{row['frame_cnt_appeals']}}
  </a>
</ng-template>

<ng-template #frame_remote_url let-row="row">
  @if (row['frame_cnt_appeals'].length) {
    @for (el of row['frame_cnt_appeals']; track el) {
      <p>
        {{el}}
      </p>
    }
  }
</ng-template>

<ng-template #button let-row="row">
  <a class="button button_icon" title="Просмотр" [routerLink]="['/statistic/plugin/', row.frame_www_uuid]">
    <i class="fa fa-fw fa-cog"></i>
  </a>
</ng-template>
